"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _find = _interopRequireDefault(require("lodash/find"));

var _shared = require("@widget-editor/shared");

var _reactSelect = _interopRequireDefault(require("react-select"));

var _ChartMenu = _interopRequireDefault(require("./components/ChartMenu"));

var _style = require("./style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var SelectChart = function SelectChart(_ref) {
  var patchConfiguration = _ref.patchConfiguration,
      options = _ref.options,
      chartType = _ref.chartType,
      theme = _ref.theme,
      advanced = _ref.advanced,
      setTheme = _ref.setTheme;

  var _ref2 = (0, _react.useState)((0, _find["default"])(options, {
    chartType: chartType
  })),
      _ref3 = _slicedToArray(_ref2, 2),
      selected = _ref3[0],
      setSelected = _ref3[1];

  (0, _react.useEffect)(function () {
    if (selected && selected.chartType !== chartType) {
      setSelected((0, _find["default"])(options, {
        chartType: chartType
      }));
    }
  }, [chartType, selected, options]);
  var _theme$compact = theme.compact,
      isCompact = _theme$compact.isCompact,
      forceCompact = _theme$compact.forceCompact,
      isOpen = _theme$compact.isOpen;

  var _ref4 = (0, _react.useState)(false),
      _ref5 = _slicedToArray(_ref4, 2),
      isOpenMenu = _ref5[0],
      setIsOpenMenu = _ref5[1];

  var handleChange = function handleChange(option) {
    var chartType = option.chartType;
    patchConfiguration({
      chartType: chartType,
      visualizationType: chartType === "map" ? "map" : "chart"
    });
    setSelected(option);
    setIsOpenMenu(false);
  };

  var hadleSettings = function hadleSettings() {
    setTheme(_objectSpread({}, theme, {
      compact: {
        isCompact: isCompact,
        forceCompact: forceCompact,
        isOpen: !isOpen
      }
    }));
  };

  return _react["default"].createElement(_style.StyledContainer, {
    isCompact: isCompact || forceCompact
  }, advanced && _react["default"].createElement(_style.StyledSelectBox, {
    isCompact: isCompact || forceCompact
  }, _react["default"].createElement(_reactSelect["default"], {
    isDisabled: true,
    onChange: handleChange,
    onMenuOpen: function onMenuOpen() {
      return setIsOpenMenu(true);
    },
    onMenuClose: function onMenuClose() {
      return setIsOpenMenu(false);
    },
    value: {
      value: "custom",
      label: "Custom chart"
    },
    options: [{
      value: "custom",
      label: "Custom chart"
    }],
    styles: _style.InputStyles,
    components: {
      Menu: _ChartMenu["default"]
    },
    menuIsOpen: isOpenMenu
  })), !advanced && _react["default"].createElement(_style.StyledSelectBox, {
    isCompact: isCompact || forceCompact
  }, _react["default"].createElement(_reactSelect["default"], {
    onChange: handleChange,
    onMenuOpen: function onMenuOpen() {
      return setIsOpenMenu(true);
    },
    onMenuClose: function onMenuClose() {
      return setIsOpenMenu(false);
    },
    value: selected,
    options: options,
    styles: _style.InputStyles,
    components: {
      Menu: _ChartMenu["default"]
    },
    menuIsOpen: isOpenMenu
  })), (isCompact || forceCompact) && _react["default"].createElement(_shared.Button, {
    btnType: "highlight",
    onClick: function onClick() {
      return hadleSettings();
    }
  }, "Settings"));
};

SelectChart.propTypes = {
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string.isRequired,
    value: _propTypes["default"].string.isRequired
  }))
};
var _default = SelectChart;
exports["default"] = _default;